<template>
  <v-list-item
    :class="computedClass"
    :data-active="active"
    :data-disabled="disable"
    :disabled="!isGroup && disable"
    @click="!disable ? $emit('click') : null"
  >
    <template v-if="canSelect" #prepend>
      <v-checkbox hide-details readonly :disabled="disable" :model-value="active" />
    </template>

    <div class="ag-autocomplete__content">
      <v-list-item-title class="ag-autocomplete__item-title" :has-subtitle="!!subtitle">
        <AGTruncatedText>
          {{ title }}
        </AGTruncatedText>
      </v-list-item-title>

      <v-list-item-subtitle v-if="isSubtitleVisible" class="ag-autocomplete__item-subtitle">
        <AGTruncatedText>
          {{ subtitleMessage }}
        </AGTruncatedText>
      </v-list-item-subtitle>
    </div>

    <template v-if="$slots.action" #append>
      <slot name="action" />
    </template>
  </v-list-item>
</template>

<script>
import AGTruncatedText from '@/components/common/AGTruncatedText.vue';

export default {
  components: { AGTruncatedText },

  emits: ['click'],

  props: {
    title: {
      type: [String, Number],
      default: '',
    },

    subtitle: {
      type: [String, Number],
      default: '',
    },

    disableMessage: {
      type: String,
      default: '',
    },

    disable: {
      type: Boolean,
      default: false,
    },

    active: {
      type: Boolean,
      default: false,
    },

    canSelect: {
      type: Boolean,
      default: false,
    },

    isGroup: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    computedClass() {
      return this.isGroup ? 'ag-autocomplete__group' : 'ag-autocomplete__item';
    },
    itemHasSubtitleAndIsNotDisabled() {
      return this.subtitle && !this.disable;
    },
    itemIsDisabledAndHasDisabledMessage() {
      return this.disable && this.disableMessage;
    },
    isSubtitleVisible() {
      return this.itemHasSubtitleAndIsNotDisabled || this.itemIsDisabledAndHasDisabledMessage;
    },
    subtitleMessage() {
      if (this.itemHasSubtitleAndIsNotDisabled) return this.subtitle;
      else if (this.itemIsDisabledAndHasDisabledMessage) return this.disableMessage;
      else return null;
    },
  },
};
</script>

<style scoped lang="scss">
.ag-autocomplete__item,
.ag-autocomplete__group {
  width: 100%;
  height: 64px !important;
  min-height: 64px;
  padding: $spacing-05 !important;
  cursor: pointer;

  &:hover {
    background-color: $brand-color-highlight-light !important;
  }

  &[data-disabled='true'] {
    background-color: $neutral-color-low-dark !important;
    cursor: default;
  }
}

.ag-autocomplete__item {
  background-color: $neutral-color-low-light;

  &[data-active='true'] {
    background-color: $brand-color-primary-light !important;
    opacity: 1 !important;
  }
}

.ag-autocomplete__group {
  background-color: $neutral-color-low-medium !important;
}

.ag-autocomplete__content {
  margin-left: $spacing-02;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  gap: $spacing-01;

  .ag-autocomplete__item-title,
  .ag-autocomplete__item-subtitle {
    width: 100%;
    align-self: self-start;
    font-size: $font-size-xs;
    line-height: 1;
    margin: 0;
    display: block;

    ::v-deep(.ag-truncated-text) {
      pointer-events: all;
    }
  }

  .ag-autocomplete__item-title {
    color: $neutral-color-high-dark;

    &[has-subtitle='true'] {
      font-weight: $font-weight-bold;
    }
  }

  .ag-autocomplete__item-subtitle {
    color: rgba(0, 0, 0, 0.6);
    opacity: 1;
  }
}

.v-list-item__action {
  margin-right: 4px !important;
}
</style>
